import Vue from 'vue';

export default {
    
      async fetchPersonnelByDprId({ commit }, dprId) {
        return Vue.axios.get(Vue.$url("personnel/"+ dprId + "/available"))
          .then((rsp) => commit("SET_PERSONNEL", rsp.data))
          
      },

      async fetchPersonnelStatuses({ commit }) {
        return Vue.axios.get(Vue.$url("personnel/statuses"))
          .then((rsp) => commit("SET_PERSONNEL_STATUSES", rsp.data))
      },
 
}